const isMessageAllowance = (feature) => /^\d+\s+included WhatsApp messages per month\*$/i.test(feature);

export const buildPlanFeatures = (definitions) => {
  let included = [];
  return definitions.map((plan) => {
    included = [...included, ...plan.additions];
    const currentAllowance = plan.additions.filter(isMessageAllowance);
    const features = [
      ...included.filter((feature) => !isMessageAllowance(feature)),
      ...currentAllowance,
    ];
    return { ...plan, features };
  });
};
